import { last } from 'ramda';
import { useEffect } from 'react';

import { useAuthenticationContext } from '@speeki/firebase-chat';
import { notify } from '@speeki/global-ui-components';

import {
    ChatRoomFileInfoDocument,
    ChatRoomFileUrlDocument,
} from '@graphql/generated/graphql';

import { useLazyQuery } from '@apollo/client';

export const useCustomMessageFile = (uuid: string | undefined | null) => {
    const { authMetadata } = useAuthenticationContext();
    const [getFileData, { data, loading: dataLoading }] = useLazyQuery(
        ChatRoomFileInfoDocument,
        {
            context: {
                firebaseToken: authMetadata?.token,
            },
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'cache-first',
        },
    );
    const [getFileUrl, { loading: urlLoading }] = useLazyQuery(
        ChatRoomFileUrlDocument,
        {
            context: { firebaseToken: authMetadata?.token },
            fetchPolicy: 'no-cache',
        },
    );

    const assignExtension = () => {
        if (!data) return;
        const extension = last(
            data.chatRoomFileInfo.name.split('.'),
        )?.toLowerCase();

        return { ...data.chatRoomFileInfo, extension };
    };

    const openFile = async () => {
        if (!uuid) return;

        const { data, error } = await getFileUrl({
            variables: { fileUuid: uuid },
        });

        if (error) {
            console.error({ error });
            notify(error.message).ERROR();

            return;
        }

        window.open(data?.chatRoomFileInfo.signedUrl, '_blank');
    };

    useEffect(() => {
        !!uuid && void getFileData({ variables: { fileUuid: uuid } });
    }, [uuid]);

    return {
        data: data ? assignExtension() : undefined,
        loading: (dataLoading || urlLoading) ?? true,
        openFile,
    };
};
